import styled from 'styled-components';

export const SignupStyle = styled.section`
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction:column;
    align-items:center;
    justify-content: center;
    background-color:#DDDDDD;
    padding: 0 1rem;
`